import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const DoublePerPageIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M3,6A1,1,0,0,0,2,7V17a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V9L8,6ZM7.5,9.5V6.75L10.25,9.5ZM14,6a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V9L19,6Zm4.5,3.5V6.75L21.25,9.5Z" />
    </g>
  </SvgIcon>
);

export default DoublePerPageIcon;
